import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuthStore } from '../store/adminAuthStore';
import { firstAdminPath } from '../config/permissions.config';

interface AdminPermissionGuardProps {
  permission: string;
  children: React.ReactNode;
}

/**
 * Admin Console route guard — passes when the admin holds `permission` or is
 * super admin. Redirects to the first allowed admin section, or a forbidden
 * page when the user has no admin permissions at all.
 */
export const AdminPermissionGuard: React.FC<AdminPermissionGuardProps> = ({ permission, children }) => {
  const { has, admin } = useAdminAuthStore();

  if (has(permission)) {
    return <>{children}</>;
  }

  const fallback = firstAdminPath(has, admin?.permissions ?? []);
  return <Navigate to={fallback ?? '/admin/forbidden'} replace />;
};

export default AdminPermissionGuard;
